import React, { useEffect } from "react";
import Aos from "aos";
import ImageZoom from "react-medium-image-zoom";
import "aos/dist/aos.css";
import "react-medium-image-zoom/dist/styles.css";
import "./Noticias.css"; // importa o CSS novo

const noticiasData = [
  {
    "data": "04/10/2025",
    "titulo": "Automotive Industry Week",
    "descricao": " Plastifa marcará presença na '12th Automotive Industry Week', organizada pela AFIA! \nEstaremos na sala 'New York' do Hotel Solverde, em Vila Nova de Gaia, dias 4,5 e 6 de Novembro",
    "imagem": "images/AFIA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_innovation-automotiveindustry-plastifa-activity-7378706061240926208-qsqS?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "02/10/2025",
    "titulo": "SCORING TOP 5%",
    "descricao": "Plastifa renova o estatuto “TOP 5% Melhores PME de Portugal” — pelo 6.º ano consecutivo. \nÉ com enorme orgulho que anunciamos a renovação desta distinção, atribuída pela SCORING.",
    "imagem": "images/TOP2025.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plastifa-top5-scoring-activity-7381254954105135104-Rcn0?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "01/09/2025",
    "titulo": "IAA MOBILITY 2025",
    "descricao": "A PLASTIFA tem o prazer de participar na IAA MOBILITY 2025",
    "imagem": "images/IAA.jpeg",
    "link": "https://www.linkedin.com/posts/plastifa_plasticparts-mobility-automotive-activity-7360664420571578368-TTnd?utm_source=share&utm_medium=member_desktop&rcm=ACoAABlgsDEB4kuQzF5X4QeN1En5h3lZmYDQYFw",
    "zoom": false
  },
  {
    "data": "15/05/2024",
    "titulo": "ISO 14001",
    "descricao": "Com foco no Ambiente e num Futuro mais sustentável a Plastifa certificou-se ISO 14001 - Sistema de Gestão Ambiental.",
    "imagem": "images/14001.jpeg",
    "link": "https://www.linkedin.com/feed/update/urn:li:activity:7196080381643616257",
    "zoom": false
  },
  {
    "data": "23/12/2023",
    "titulo": "Um futuro mais verde",
    "descricao": "Com foco na Sustentabilidade e num Futuro mais verde, a Plastifa dá o passo de investir na produção de Energia Solar.",
    "imagem": "images/PaineisSolares.JPG",
    "link": "https://www.linkedin.com/posts/plastifa_com-foco-na-sustentabilidade-e-num-futuro-activity-7157008055249821696-QJP5",
    "zoom": false
  },
  {
    "data": "25/10/2023",
    "titulo": "SCORING TOP 5%",
    "descricao": "A empresa foi pelo 4º ano consecutivo reconhecida como parte do TOP 5% MELHORES PME DE PORTUGAL ao nível de Desempenho e Solidez Financeira!",
    "imagem": "images/TOP52023.png",
    "zoom": true
  },
  {
    "data": "01/06/2023",
    "titulo": "Novo Vídeo",
    "descricao": "Num mundo impulsionado pelo constante progresso e inovação, a Plastifa tem orgulho em fazer uma breve apresentação da sua empresa com tecnologia de ponta e ideias inovadoras.",
    "imagem": "images/NotVideo.png",
    "link": "https://www.linkedin.com/posts/plastifa_plastifa-your-partner-for-plastic-parts-activity-7059587841172865024-LQ9A",
    "zoom": false
  },
  {
    "data": "17/10/2022",
    "titulo": "SCORING TOP 5%",
    "descricao": "A empresa foi pelo terceiro ano consecutivo reconhecida como parte do TOP 5% MELHORES PME DE PORTUGAL ao nível de Desempenho e Solidez Financeira!",
    "imagem": "images/TOPSCORING22.png",
    "zoom": true
  },
  {
    "data": "23/12/2021",
    "titulo": "Postal de Natal",
    "descricao": "Por favor, carregar na imagem em baixo para aceder ao Postal de Natal da Plastifa:",
    "imagem": "images/Natal.png",
    "link": "https://plastifa.pt/Natal",
    "zoom": false
  },
  {
    "data": "15/11/2021",
    "titulo": "SCORING TOP 5%",
    "descricao": "A empresa foi pelo segundo ano consecutivo reconhecida como parte do TOP 5% MELHORES PME DE PORTUGAL ao nível de Desempenho e Solidez Financeira!",
    "imagem": "images/TOP2021.jpg",
    "zoom": true
  },
  {
    "data": "24/04/2021",
    "titulo": "PME Excelência",
    "descricao": "A Plastifa renova pelo 7º ano consecutivo o estatuto PME Excelência.",
    "imagem": "images/PMEex3.png",
    "zoom": true
  },
  {
    "data": "24/12/2020",
    "titulo": "SCORING TOP 5%",
    "descricao": "A empresa foi reconhecida como parte do TOP 5% MELHORES PME DE PORTUGAL ao nível de Desempenho e Solidez Financeira!",
    "imagem": "images/TOP52020.jpg",
    "zoom": true
  },
  {
    "data": "16/04/2020",
    "titulo": "EPI’s Plastifa",
    "descricao": "De forma a fazer a sua parte na luta contra a Pandemia Covid 19, a Plastifa dedicou-se ao fabrico de Viseiras e Fixadores para máscaras.",
    "imagem": "images/Viseiras.png",
    "zoom": true
  },
  {
    "data": "02/10/2020",
    "titulo": "Expansão a Plastifa Unidade 2",
    "descricao": "A Plastifa avançou para a construção de mais uma nave de 1.000 m2 na Unidade 2.",
    "imagem": "images/ExpUn2.jpeg",
    "zoom": true
  }
];

const Noticias = () => {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);

  return (
    <div className="noticias-wrapper">
      <div className="noticias-grid">
        {noticiasData.map((noticia, idx) => (
          <article key={idx} className="noticia-card" data-aos="fade-up">
            <div className="noticias-row2">
              <label>{noticia.data}</label>
              <h3 className="noticia-titulo">{noticia.titulo}</h3>
            </div>
            <p
              className="noticia-desc"
              dangerouslySetInnerHTML={{
                __html: noticia.descricao.replace(/\n/g, "<br>")
              }}
            ></p>
            <div className="noticia-media">
              {noticia.zoom ? (
                <ImageZoom
                  image={{ src: noticia.imagem, alt: noticia.titulo, className: "noticia-img" }}
                  zoomImage={{ src: noticia.imagem, alt: noticia.titulo }}
                />
              ) : noticia.link ? (
                <a href={noticia.link} target="_blank" rel="noreferrer">
                  <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
                </a>
              ) : (
                <img src={noticia.imagem} alt={noticia.titulo} className="noticia-img" />
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Noticias;